import { FC, useMemo } from 'react';
import { useBooleanValue } from '@edikk-edikk/hooks';
import { Subject } from 'rxjs';
import { useIntl } from 'react-intl';
import { Detail } from '#advertList/components/filter/detail/Detail';
import { FilterContext } from '#advertList/components/filter/contexts/FilterContext';
import { FilterContextType } from '#advertList/components/filter/contexts/FilterContextType';
import { Controls } from '#advertList/components/filter/controls/Controls';
import { useAdvertListContext } from '#advertList/hooks/use-advert-list-context';
import { FilterItem } from '#advertList/components/filter/types/FilterItem';

const Filter: FC = () => {
  const { filterData } = useAdvertListContext();

  const [isVisible, open, hide] = useBooleanValue(false);
  const onChangeSubject = useMemo(() => new Subject<string>(), []);
  const intl = useIntl();
  const filterItemList: FilterItem[] = useMemo(
    () => {
      if (filterData.areaList) {
        return filterData.areaList.map((area) => FilterItem.initByArea(intl, area));
      }
      if (filterData.cityList) {
        return filterData.cityList.map((city) => FilterItem.initByCity(intl, city));
      }
      if (filterData.categoryList) {
        return filterData.categoryList.map((category) => FilterItem.initByCategory(intl, category));
      }
      return [];
    },
    [filterData.areaList, filterData.categoryList, filterData.cityList, intl],
  );

  if (filterItemList.length === 0) {
    return null;
  }

  const filterContextValue: FilterContextType = {
    isVisible,
    open,
    hide,
    onChangeSubject,
    filterItemList,
  };

  return (
    <FilterContext.Provider value={filterContextValue}>
      <div>
        <Controls />
        <Detail />
      </div>
    </FilterContext.Provider>
  );
};

export { Filter };
